import React, { useState, useEffect } from 'react';
import {
    Grid,
    Box,
    Typography,
    IconButton,
    Button
} from '@mui/material';
import Loading from '../../Loading';
import { Link, withRouter } from 'react-router-dom';
import Select from '../../Common/Select';
import DateInput from '../../Common/DateInput';
import Input from '../../Common/InputField';
import CloseIcon from '@mui/icons-material/Close';
import SimpleButton from '../../Common/Button'


function AirFilterChangeOut(props) {

    const [id, setId] = useState(null);
    const [dueDate, setDueDate] = useState(null);
    const [locationId, setLocationId] = useState(null);
    const [locationError, setLocationError] = useState(null);
    const [priorityId, setPriorityId] = useState(null);
    const [priorities, setPriorities] = useState([]);

    const [workOrderNumber, setWorkOrderNumber] = useState('');
    const [workOrderNumberError, setWorkOrderNumberError] = useState(null);

    const [successfulPopup, setSuccessfulPopup] = useState(false);
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [initialData, setInitialData] = useState(null);
    const [activeTab, setActiveTab] = useState('ServiceEvents')


    //Passing in a second argument of an empty array makes this only fire on the initial render
    useEffect(() => {
        setId(props.match.params.id);
        setLoading(false)


    }, []);




    function handleSelect(key) {
        setActiveTab(key);
    }

    return (
        <div>
            {loading ?
                <div><Loading /></div>
                :
                <div>
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={{ maxWidth: '65%', marginBottom: '2%' }}
                    >
                        <Grid item>
                            <Link to="/WorkOrders">
                                <IconButton aria-label="close">
                                    <CloseIcon />
                                </IconButton>
                            </Link>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" style={{ color: '#1A173B' }}>
                                Work Order ID #{id}
                            </Typography>
                        </Grid>
               
                        <Grid item style={{ marginLeft: 'auto', marginRight: "40px" }}>
                         <SimpleButton
                           text="Save"
                           onClick={() => console.log("Saved")} />
                        </Grid> 
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={{ maxWidth: '65%', marginBottom: '2%' }}
                    >

                        <Grid container spacing={4} justifyContent='center'>
                            <Grid item xs={6} md={6} lg={6}>
                                <Select
                                    required
                                    label="Primary Technician"
                                    value={1}
                                    options={[{ label: 'Nathan', value: 1 }]}
                                />
                            </Grid>
                            <Grid item xs={6} md={6} lg={6}>
                                <DateInput
                                    required
                                    label="Service Date"
                                />
                            </Grid>
                        </Grid>


                        <Grid container spacing={4} justifyContent='center' style={{ marginTop: '1%' }}>
                            <Grid item xs={6} md={6} lg={6}>
                                <Typography variant="p" style={{ color: '#1A173B' }}>
                                    Select the air filters systems below and mark then as * Changed Out *
                                </Typography>
                            </Grid>
                            <Grid item xs={6} md={6} lg={6}>
     
                            </Grid>
                        </Grid>

                        <Grid container spacing={4} justifyContent='center' style={{ marginTop: '1%' }}>
                            <Grid item xs={6} md={6} lg={6}>
                                <Typography variant="p" style={{ color: '#1A173B' }}>
                                    Select the air filters systems below and mark then as * Changed Out *
                                </Typography>
                            </Grid>
                            <Grid item xs={6} md={6} lg={6}>

                            </Grid>
                        </Grid>


                        <Grid container spacing={4} justifyContent='center' style={{ marginTop: '1%' }}>

                        </Grid>
                    </Grid>
                </div>

            }
        </div>
    )
}

export default AirFilterChangeOut;